import React from 'react';

const ShippingAddress = () => {
  return <div>Shipping Address</div>;
};

export default ShippingAddress;
